const nostoLoadMoreButton = document.querySelector('#nosto-load-more')
if (nostoLoadMoreButton) {
  const handleIntersection = (entries, observer) => {
    if (entries[0].isIntersecting) {
      nostoLoadMoreButton.classList.add('visible')
      setTimeout(() => nostoLoadMoreButton.click(), 1000)
    } else {
      nostoLoadMoreButton.classList.remove('visible')
    }
  }

  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: '0px 0px -20% 0px'
  })

  observer.observe(nostoLoadMoreButton)
}
